import { useEffect, useState } from 'react'

import CardVaga from '../../components/CardVaga'

import * as Global from '../../styles/index'
import * as S from './styles'

import { useGetVagasQuery } from '../../services/api'

const Vagas = () => {
  const { data: vagas } = useGetVagasQuery()

  if (!vagas) {
    return (
      <>
        <Global.Container className="placeholder-glow">
          <h3 className="text-center text-white mt-4">
            Carregando vagas disponíveis
          </h3>
          <S.CardPlaceholder className="placeholder mb-0" />
          <S.CardPlaceholder className="placeholder mb-0" />
          <S.CardPlaceholder className="placeholder mb-0" />
        </Global.Container>
      </>
    )
  }

  return (
    <S.VagasContainer>
      <Global.Container>
        {vagas.map((vaga) => (
          <div key={vaga.id}>
            <CardVaga
              id={vaga.id}
              nome_vaga={vaga.nome_vaga}
              desc_vaga={vaga.desc_vaga}
              req_vaga={vaga.req_vaga}
              salario={vaga.salario}
              created_at={vaga.created_at}
              disponivel={vaga.disponivel}
            />
          </div>
        ))}
      </Global.Container>
    </S.VagasContainer>
  )
}

export default Vagas
